export const EMPTY_APP = 'App/EMPTY_APP';

export const FETCH_INDUSTRY_EXPERIENCE_TYPES = 'App/FETCH_INDUSTRY_EXPERIENCE_TYPES';
export const FETCH_INDUSTRY_EXPERIENCE_TYPES_SUCCESS = 'App/FETCH_INDUSTRY_EXPERIENCE_TYPES_SUCCESS';
export const FETCH_INDUSTRY_EXPERIENCE_TYPES_FAILURE = 'App/FETCH_INDUSTRY_EXPERIENCE_TYPES_FAILURE';

export const FETCH_LOCATIONS = 'App/FETCH_LOCATIONS';
export const FETCH_LOCATIONS_SUCCESS = 'App/FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_FAILURE = 'App/FETCH_LOCATIONS_FAILURE';

export const FETCH_SKILLS = 'App/FETCH_SKILLS';
export const FETCH_SKILLS_SUCCESS = 'App/FETCH_SKILLS_SUCCESS';
export const FETCH_SKILLS_FAILURE = 'App/FETCH_SKILLS_FAILURE';

export const FETCH_SPECIALTIES = 'App/FETCH_SPECIALTIES';
export const FETCH_SPECIALTIES_SUCCESS = 'App/FETCH_SPECIALTIES_SUCCESS';
export const FETCH_SPECIALTIES_FAILURE = 'App/FETCH_SPECIALTIES_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/App/store/constants.js